import { useEffect } from "react";
import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { BottomNav } from "@/components/BottomNav";
import { CookieBanner } from "@/components/CookieBanner";
import { MagicCursor } from "@/components/MagicCursor";
import HomePage from "@/pages/HomePage";
import ListingPage from "@/pages/ListingPage";
import ProductPage from "@/pages/ProductPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import LegalPage from "@/pages/LegalPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import SellerPage from "@/pages/SellerPage";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname, search]);
  return null;
};

const PromoBar = () => (
  <div className="bg-gradient-to-r from-gold-600 via-gold-500 to-gold-600 text-navy-900" data-testid="promo-bar">
    <a
      href="https://link.amazon/B0enMSD6L"
      target="_blank"
      rel="nofollow sponsored noopener"
      data-testid="promo-bar-link"
      className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-center text-xs font-bold sm:text-sm"
    >
      <span className="hidden sm:inline">Prime Big Deal Days are live on Amazon —</span>
      <span className="sm:hidden">Prime Big Deal Days —</span>
      <span className="underline underline-offset-2">Shop top deals now →</span>
    </a>
  </div>
);

const NotFound = () => (
  <div className="mx-auto max-w-4xl px-4 py-24 text-center" data-testid="not-found-page">
    <h1 className="font-heading text-4xl font-extrabold text-slate-900">404 — nothing here</h1>
    <p className="mt-3 text-slate-500">This page wandered off. Let's get you back to the deals.</p>
    <Link to="/" data-testid="not-found-home-link" className="mt-6 inline-block rounded-xl bg-rose-600 px-6 py-3 text-sm font-bold text-white hover:bg-rose-700">
      Back to homepage
    </Link>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col">
        <PromoBar />
        <Header />
        <main className="flex-1 pb-20 md:pb-0">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/category/:slug" element={<ListingPage key="category" mode="category" />} />
            <Route path="/deals" element={<ListingPage key="deals" mode="deals" />} />
            <Route path="/trending" element={<ListingPage key="trending" mode="trending" />} />
            <Route path="/search" element={<ListingPage key="search" mode="search" />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/sell" element={<SellerPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <BottomNav />
        <MagicCursor />
        <CookieBanner />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
